// web-ctr/src/lib/specimens.js
// Global's specimen PDFs, published from web-ctr/public/specimens/ (round
// 3.1). ONE home for the paths: PolicyDiff and the coverage page's
// endorsement link both read here. The files are Global's own specimens,
// marked SAMPLE; source of truth for their copy is
// docs/clearedto-rent/specimens/README.md.
export const BNO_SPECIMEN_URL = '/specimens/Global-BNO-Sample-Policy.pdf';
export const C123_SPECIMEN_URL = '/specimens/Global-CFI-Specimen-Endorsement-1.pdf';
